// Kart ödemesi kabul edildiğini belirten güven rozetleri — resmi marka
// logoları (bkz. public/payments/ ve public/payment-logos/), her sağlayıcının
// kendi marka kurallarına uygun şekilde, sadece kabul edilen ödeme
// yöntemlerini belirtmek amacıyla gösterilir. PayTR/iyzico logoları
// sağlayıcıların kendi resmi marka paketlerinden alındı. Hem Footer hem Hero
// bu bileşeni kullanır — `size` ile boyut ayarlanır.
const SIZES = {
  md: { pad: "h-9 px-3", visa: "h-4", mastercard: "h-6", troy: "h-[18px]", paytr: "h-4", iyzico: "h-[18px]", gap: "gap-2.5" },
  lg: { pad: "h-12 px-4", visa: "h-5", mastercard: "h-8", troy: "h-6", paytr: "h-5", iyzico: "h-6", gap: "gap-3" },
};

export default function PaymentBadges({ size = "md", className = "" }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <div
      className={`flex items-center ${s.gap} flex-wrap ${className}`}
      data-testid="payment-badges"
      aria-label="Kabul edilen kartlar ve ödeme sağlayıcıları: Visa, Mastercard, Troy, PayTR, iyzico"
    >
      <span className={`${s.pad} rounded-md bg-white flex items-center justify-center shrink-0 shadow-sm`}>
        <img src="/payments/visa.svg" alt="Visa" className={s.visa} />
      </span>
      <span className={`${s.pad} rounded-md bg-white flex items-center justify-center shrink-0 shadow-sm`}>
        <img src="/payments/mastercard.svg" alt="Mastercard" className={s.mastercard} />
      </span>
      <span className={`${s.pad} rounded-md bg-white flex items-center justify-center shrink-0 shadow-sm`}>
        <img src="/payments/troy.png" alt="Troy" className={s.troy} />
      </span>
      <span className={`${s.pad} rounded-md bg-white flex items-center justify-center shrink-0 shadow-sm`}>
        <img src="/payment-logos/paytr.png" alt="PayTR" className={s.paytr} />
      </span>
      <span className={`${s.pad} rounded-md bg-white flex items-center justify-center shrink-0 shadow-sm`}>
        <img src="/payment-logos/iyzico-horizontal.svg" alt="iyzico" className={s.iyzico} />
      </span>
    </div>
  );
}
